import { createFileRoute } from '@tanstack/react-router'
import { ExternalLink } from 'lucide-react'

export const Route = createFileRoute('/auth/staff-redirect')({
  component: StaffRedirectPage,
})

function StaffRedirectPage() {
  return (
    <div
      style={{
        alignItems: 'center',
        background: 'var(--bg)',
        display: 'flex',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
      }}
    >
      <div
        style={{
          background: 'var(--bg2)',
          border: '1px solid var(--lime-line)',
          borderRadius: '16px',
          maxWidth: '400px',
          padding: '40px',
          textAlign: 'center',
          width: '100%',
        }}
      >
        <div
          style={{
            color: 'var(--text)',
            fontFamily: 'Clash Display',
            fontSize: '22px',
            fontWeight: 700,
            marginBottom: '12px',
          }}
        >
          You're a staff member
        </div>
        <p style={{ color: 'var(--muted)', fontSize: '14px', marginBottom: '28px' }}>
          Owner, manager, and admin accounts are managed through the staff portal.
        </p>
        <a
          href="https://portal.turfchale.com"
          style={{
            alignItems: 'center',
            background: 'var(--lime)',
            borderRadius: '10px',
            color: '#0b1c10',
            display: 'inline-flex',
            fontSize: '15px',
            fontWeight: 600,
            gap: '8px',
            padding: '12px 24px',
            textDecoration: 'none',
          }}
        >
          Go to portal.turfchale.com
          <ExternalLink size={15} />
        </a>
      </div>
    </div>
  )
}
